import {Injectable, OnDestroy} from '@angular/core';
import {AuthService} from '@app/core/services/auth.service';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {HttpService} from '@app/core/services/http.service';
import {Observable, Subscription} from 'rxjs';
import {Department} from '@app/core/models/department.model';
import {DepartmentService as OldDepartmentService} from '@app/modules/shared/services/department.service';
import {map} from 'rxjs/operators';
import {RoundingRule} from '@app/core/models/roundingRule.model';
import {PaginationHolder} from '@app/core/models/pagination.model';

export interface IRoundingRulesFilters {
	'filter[department_id]'?: string | number;
	'filter[type]'?: string;
	'filter[method]'?: string;
}

export interface IDepartmentPostPayload {
	department_name: string;
	hub_venue_id?: string;
}

@Injectable({
	providedIn: 'root',
})

export class DepartmentService implements OnDestroy {

	public subscriptions: Subscription[] = [];

	constructor(
		public authService: AuthService,
		public interService: InternationalizationService,
		public httpService: HttpService,
		private oldDepartmentService: OldDepartmentService,
	) {
	}

	public getDepartments(): Observable<Department[]> {
		return this.httpService.getJson<Department[]>('departments')
			.pipe(map((res: any[]) => res.map(department => this.oldDepartmentService.fresh(department))));
	}

	public postDepartment(payload: IDepartmentPostPayload): Observable<Department> {
		return this.httpService.postJson<Department>('departments', payload);
	}

	public getInformationForCreatingUser(): Observable<Department[]> {
		return this.httpService.getJson<Department[]>('users/informationForCreatingUser')
			.pipe(map((res: any[]) => res.map(department => this.oldDepartmentService.fresh(department))));
	}

	public getRoundingRules(filters: IRoundingRulesFilters = {}): Observable<RoundingRule[]> {
		return this.httpService.getJson<PaginationHolder<RoundingRule>>('roundingRules', filters).pipe(map(res => res.data));
	}

	public ngOnDestroy(): void {
		this.subscriptions.forEach(s => s.unsubscribe());
	}
}
